<template>
  <div class="ConfInter">
    <div class="titlePage">Reporte Saber PRO</div>
    <va-notification color="danger" v-if="refNoData" class="refNoData">No se encuentran datos en este momento.</va-notification>
    <div class="listData">
      <iframe title="Tablero Saber PRO" width="600" height="373.5" src="https://app.powerbi.com/view?r=eyJrIjoiZjU0ZTJiMjAtN2EwOC00YjYzLTkyNjktZDU2OWQwNzBhYmIzIiwidCI6ImJhNWIwYTRkLTZjNjgtNGFjMy05ZDZlLWM1YjVhMTJhOWQ2OSIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'ReportInter',
  data () {
    return {
      FilterData: [
        {
        },
      ],
      HDDataList: [
      ],
      DLDataList: [],
      refNoData: false,
      caseModel: [],
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
    }
  },

  methods: {
    loadList () {

    },
  },
  created: function () {
    this.loadList()
  },
}
</script>